<template>
  <img
    @click="goToHome()"
    class="logo-image cursor-pointer"
    src="@/images/container_alliance_logo.svg"
    alt="container alliance logo"
  />
</template>
<script>
export default {
  methods:{
    goToHome() {
      window.location.href = '/'
    }
  }
}
</script>
<style>
.logo-image {
  width: 118.07px;
  height: 38px;
}
</style>